var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"no-padding bordered-container",attrs:{"fluid":""}},[_c('v-row',{staticClass:"ma-0 pa-0",attrs:{"no-gutters":""}},[_c('v-col',[_c('ManufacturingLogbookReferenceSheetPanel')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }